import React, { useContext } from 'react';
import Info from './Info';
import PropTypes from 'prop-types';
import { SettingsContext } from '../providers/SettingsProvider';
import ShareButton from './ShareButton';
import { roundToFixed } from '../helpers/math';
import styles from './Results.module.scss';
import useLocalize from '../hooks/use-localize';

const Results = ({ crustRatio, ratio }) => {
  const { localize } = useLocalize();
  const { isCrustEnabled } = useContext(SettingsContext);

  return (
    <div className={styles.result}>
      <div className={styles.ratio}>
        <div className={styles.label}>{localize('results.coefficient.label')}</div>
        <div className={styles.value}>{roundToFixed(ratio, 2)}</div>
        <Info className={styles.start}>{localize('results.coefficient.hint')}</Info>
        <ShareButton />
      </div>
      {isCrustEnabled && crustRatio >= 0 ? (
        <div className={styles.ratio}>
          <div className={styles.label}>{localize('results.dough_coefficient.label')}</div>
          <div className={styles.value}>{roundToFixed(crustRatio, 2)}</div>
          <Info className={styles.start}>{localize('results.dough_coefficient.hint')}</Info>
        </div>
      ) : null}
    </div>
  );
};

Results.propTypes = {
  crustRatio: PropTypes.number.isRequired,
  ratio: PropTypes.number.isRequired,
};

export default Results;
